<template>
  <div>
    <div class="header display-flex align-center" :style="setBg">
      <div class="width-1200 display-flex justify-between align-center">
        <div class="flex-align-center">
          <div
            class="header-logo margin-r-30 cursor-pointer"
            @click="router.push('home')"
          >
            <img
              src="https://ali-file-cdn.iol8.com/img/logo/twinslator/logo-black.png"
              width="130"
              alt=""
            />
          </div>
          <ul
            v-if="
              !route.fullPath.includes('/overview') &&
              !route.fullPath.includes('/personalDataView') &&
              !route.fullPath.includes('/freeDetail')
            "
            class="header-menu display-flex align-center"
          >
            <li
              :class="{
                'header-meun-active': route.fullPath.includes('/experience'),
              }"
            >
              <router-link to="/experience">快速体验</router-link>
            </li>
            <li
              :class="{
                'header-meun-active':
                  route.fullPath.includes('/market') ||
                  (route.fullPath.includes('/detail') &&
                    !route.fullPath.includes('from=build')) ||
                  route.fullPath.includes('/status'),
              }"
              style="position: relative"
            >
              <span class="activityText" v-if="activityText">
                {{ activityText }}
              </span>
              <router-link to="/market">引擎矩阵</router-link>
            </li>
            <li class="cursor-pointer" @click="toYuDao">翻译API</li>
            <li
              v-if="userInfo && userInfo.casId"
              :class="{
                'header-meun-active':
                  route.fullPath.includes('/my') ||
                  (route.fullPath.includes('/detail') &&
                    route.fullPath.includes('from=build')) ||
                  route.fullPath.includes('/create') ||
                  route.fullPath.includes('/subData'),
              }"
            >
              <router-link to="/my">我的引擎</router-link>
            </li>
          </ul>
        </div>
        <div
          class="header-user display-flex align-center justify-center"
          v-if="userInfo && userInfo.casId"
        >
          <div>
            <EnterpriseDrop />
          </div>
          <div
            class="header-user-avatar display-flex align-center justify-center"
          >
            <NavigateDrop />
          </div>
        </div>
        <div class="header-login" v-else>
          <a-button type="primary" @click="login">登录/注册</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    defineComponent,
    watch,
    ref,
    computed,
    reactive,
    toRefs,
    onMounted,
  } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'

  import CubeDrop from './components/CubeDrop.vue'
  import NavigateDrop from './components/NavigateDrop.vue'
  import EnterpriseDrop from './components/EnterpriseDrop.vue'
  import ChatRoom from './components/ChatComponent.vue'
  import { checkLoginApi, checkToken, getBannerList } from '@/http/api'

  export default defineComponent({
    props: ['scrollTop'],
    components: { CubeDrop, NavigateDrop, ChatRoom, EnterpriseDrop },
    setup(props) {
      const route = useRoute()
      const router = useRouter()
      const store = useStore()
      const userInfo = computed(() => store.state.user.userInfo)
      const headerHref = window.location.href

      const redirect = ref('')
      const state = reactive({
        activityText: '',
        visible: false,
        // msgCount: 0,
      })

      watch(
        route,
        (n, o) => {
          redirect.value = (n.query && n.query.redirect) || '/'
        },
        {
          immediate: true,
        }
      )

      const toYuDao = () => {
        window.open('/go/tw_pc_login_option/open/doc/start', '_blank')
      }

      const setBg = computed(() => {
        if (route.fullPath.includes('/home')) {
          return `background: rgba(255, 255, 255, ${
            props.scrollTop / 150
          }); box-shadow: none;`
        }
        // background(255, 255, 255, 0)
      })

      const handleRoute = () => {
        return redirect.value === '/404' || redirect.value === '/403'
          ? '/'
          : redirect.value
      }

      // 获取当前路由
      const returnRoute = () => {
        return route.path
      }

      // 过滤 channel&invitePeople 字段
      const filterFunc = () => {
        let _url = ''
        if (route.path == '/detail') {
          const _query = route.query
          if (_query.channel) {
            delete _query.channel
          }
          if (_query.invitePeople) {
            delete _query.invitePeople
          }
          _url = `${window.location.origin + window.location.pathname}?id=${
            _query.id
          }&type=${_query.type}`
        } else {
          _url = location.href
        }
        return _url
      }

      // 登录
      const login = () => {
        const shareId = localStorage.shareId || ''
        const channel = localStorage.channel || ''
        const _url = filterFunc()
        let url = shareId
          ? encodeURIComponent(
              _url + `&channel=${channel}&invitePeople=` + shareId
            )
          : channel
            ? encodeURIComponent(
                _url + (_url.includes('?') ? '&' : '?') + `channel=${channel}`
              )
            : encodeURIComponent(_url)
        window.location.href = window.env.login + '/cas/login?service=' + url
        window.localStorage.removeItem('channel')
        window.localStorage.removeItem('shareId')
      }

      // 注册
      const register = () => {
        const shareId = localStorage.shareId || ''
        const channel = localStorage.channel || ''
        const _url = filterFunc()
        let url = shareId
          ? encodeURIComponent(
              _url + `&channel=${channel}&invitePeople=` + shareId
            )
          : channel
            ? encodeURIComponent(
                _url + (_url.includes('?') ? '&' : '?') + `channel=${channel}`
              )
            : encodeURIComponent(_url)
        window.location.href = window.env.login + '/register?service=' + url
        window.localStorage.removeItem('channel')
        window.localStorage.removeItem('shareId')
      }

      // 退出
      const logout = () => {
        store.dispatch('user/logout').then((res) => {
          store.commit('user/changeKey', {
            userInfo: {},
          })
          router.push('/home')
        })
      }

      // 点击显示消息中心
      const goNotice = () => {
        window.open('/go/wd_pc_login/message/center', '_blank')
      }

      // 传递子组件事件
      const getVisible = (data) => {
        if (data === false) {
          state.visible = data
        } else {
          state.msgCount = data
        }
      }

      onMounted(() => {
        getBannerList({ position: 'tw_market_bubble' }).then((res) => {
          let list = res.data.data.list
          if (list?.length) {
            state.activityText = list[0].title
          }
        })
      })

      return {
        toYuDao,
        store,
        ...toRefs(state),
        route,
        router,
        userInfo,
        message,
        msgCount: computed(() => store.state.comm.msgCount),
        setBg,
        logout,
        goNotice,
        getVisible,
        login,
        register,
        headerHref,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .header {
    //活动文字
    .activityText {
      position: absolute;
      height: 18px;
      line-height: 18px;
      font-size: 12px;
      padding: 0 6px;
      background: #f5823f;
      border-radius: 3px;
      word-break: keep-all;
      color: #ffffff;
      top: -10px;
      left: 66px;
    }
    // position: relative;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    z-index: 999;
    background-color: #fff;
    box-shadow: inset 0px -1px 0px 0px #f4f4f4;
    &.home-bg {
      background-color: transparent;
      box-shadow: none;
    }
    &.bg-201678 {
      color: #fff;
      // background: #201678;
      .header-login {
        .header-login-button {
          height: 36px !important;
          color: #333;
          background: #ffffff;
          border: 1px solid #666666;
        }
      }
      svg {
        fill: #fff;
      }
      .header-notice .icon-box:hover {
        background-color: rgba(255, 255, 255, 0.3);
      }
    }
    &.border-b-eee {
      background: #fff;
      border-bottom: 1px solid #eee;
    }
    .header-logo {
      width: 130px;
      height: 48px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .header-menu {
      margin-left: 5px;
      li {
        padding: 0 25px;
        font-size: 15px;
        color: #666;
        &.header-meun-active {
          color: #000;
          font-weight: 600;
          &:hover {
            color: #000;
          }
        }
        &:hover {
          color: #333;
        }
      }
    }
    .header-login {
      display: flex;
      align-items: center;
      button {
        height: 36px !important;
      }
      .header-login-button {
        color: #333;
        background: #ffffff;
        border: 1px solid #666666;
      }
    }
    .header-user {
      .header-user-avatar {
        width: 46px;
        height: 46px;
        overflow: hidden;
        border-radius: 23px;
        img {
          width: 100%;
        }
        .header-user-avatar-image {
          cursor: pointer;
        }
      }
      .header-user-button {
        font-size: 16px;
        color: #d74590;
        line-height: 22px;
        cursor: pointer;
        &:hover {
          color: #d74590;
        }
      }
    }
    .header-cube {
      margin-right: 10px;
    }
    .header-notice {
      cursor: pointer;
      height: 26px;
      color: #484d66;
      line-height: 26px;
      text-align: center;
      font-size: 14px;
      display: flex;
      align-items: center;
      position: relative;
      .icon-box {
        width: 32px;
        height: 32px;
        margin-right: 2px;
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        &:hover {
          background-color: #f3f7ff;
        }
      }
      svg {
        width: 18px;
        height: 18px;
        outline: none;
      }
      .twinkling {
        -webkit-animation: action 0.8s infinite;
        -moz-animation: action 0.8s infinite;
        animation: action 0.8s infinite;
      }
      .red-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #f00;
        position: absolute;
        top: 3px;
        right: 3px;
      }
      @keyframes action {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      @-webkit-keyframes action {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    }
    .home-fill {
      // fill: #fff;
      // &:hover{
      //   background-color: pink;
      // }
    }
  }
</style>
